import 'css-chunk:src/app/containers/Home/UsersView/EditUserDrawer.scss';export default {
  "EditUserDrawer": "_EditUserDrawer_1i9wu_1",
  "form": "_form_1i9wu_1",
  "submitButton": "_submitButton_1i9wu_1"
};